<!-- photo-manager.component.html -->
<ion-card-header>
    <div class="toggle-row">
      <div class="toggle-container">
        <ion-toggle
        [(ngModel)]="photosDisabled"
        (ionChange)="togglePhotoInclusion($event)"
        ></ion-toggle>
      
        <ion-text color="medium">
          <p>Disable Photos in Log Entry</p>
        </ion-text>
      </div>

      <!-- Use Last Logs Photos button - only show when no photos and last logs has photos -->
      <div class="last-logs-section" *ngIf="showLastLogsPhotosButton">
        <ion-button fill="clear" (click)="useLastLogsPhotos()">
          <ion-icon name="time-outline" slot="start"></ion-icon>
          <ion-text color="primary">Use Last Log's Photos</ion-text>
        </ion-button>
      </div>
    </div>
</ion-card-header>

<div class="photo-manager" [class.disabled-content]="photosDisabled">
  <!-- Photo Uploader Component -->
  <app-photo-uploader
    [photosDisabled]="photosDisabled"
    [isMobile]="isMobile"
    [dataLoading]="dataLoading">
  </app-photo-uploader>

  <!-- Photo Grid Viewer Component -->
  <app-photo-grid-viewer
    (deletePhoto)="deletePhoto($event)"
    [photos]="photos"
    (deleteAllPhotos)="deleteAllPhotos()"
    (copyPhotos)="copyPhotos()"
    [includeCopyPhotos]="true">

  </app-photo-grid-viewer>

</div>




